export const CHECKOUT_URL = 'https://night-en.impultienda.ar/checkout/';

export const images = {
  stack: 'https://cdn.magicpatterns.com/uploads/nPJrT6SfjLPKBA6K7ENRUM/NIGHT-EN.png',
  author: 'https://cdn.magicpatterns.com/uploads/rA44aPXwNJV6AASRhGtwAr/EMILY_CARTER_-_NIGHT.png',
};

export const stats = [
  { value: '7', label: 'Nights of implementation' },
  { value: '15', label: 'Minutes per ritual' },
  { value: '30+', label: 'Rituals & tools' },
  { value: '6', label: 'Premium volumes' },
];

export const beforeItems = [
  'You get into bed with your mind still full of unfinished tasks.',
  'You stay on your phone until the very last moment.',
  'You don’t know exactly what to do to start winding down.',
  'Every night you try something different.',
  'Your routine depends on whether you have enough time or energy.',
  'You go to bed tired without feeling like you truly ended your day.',
];

export const afterItems = [
  'Follow a simple 15-minute routine.',
  'Know exactly what to do before getting into bed.',
  'Prepare your environment for a calmer evening.',
  'Use small sensory rituals to mark the end of your day.',
  'Follow a guided plan for each of your first 7 nights.',
  'Build a routine you can continue long after the initial challenge.',
];

export const painPoints = [
  { icon: 'battery', text: 'You reach the end of the day exhausted, but your mind still feels like it’s running at full speed.' },
  { icon: 'phone', text: 'You know you should put your phone away before bed, but somehow “just five more minutes” turns into much longer.' },
  { icon: 'flame', text: 'You want a nighttime routine, but everything you’ve found feels too long or complicated.' },
  { icon: 'timer', text: 'You have very little time for yourself and need a routine you can realistically maintain.' },
  { icon: 'repeat', text: 'You’ve tried different tips before, but never managed to turn them into a consistent habit.' },
  { icon: 'moon', text: 'You want nighttime to feel like a moment for yourself instead of simply the exhausted end of another day.' },
] as const;

export const volumes = [
  {
    number: 'I',
    title: 'The 15-Minute Ritual',
    description: 'Discover the core structure of The Peaceful Night Method™ and learn how to turn the final 15 minutes before bed into a simple wind-down sequence.',
    listLabel: 'Includes',
    items: ['The 15-minute protocol', 'The 5 stages of the ritual', 'What to prepare before you begin', 'How to create a clear “end of day” signal', 'How to adapt the ritual when you have very little time', 'Complete step-by-step ritual'],
  },
  {
    number: 'II',
    title: 'Prepare Your Space for the Night',
    description: 'Your environment can help you transition into a calmer evening. Learn how to create a more relaxing nighttime atmosphere through simple adjustments.',
    listLabel: 'Simple adjustments to',
    items: ['Lighting', 'Clutter', 'Comfort', 'Sounds', 'Screens', 'Scents', 'Bedroom preparation'],
    note: 'Includes the Peaceful Night Bedroom Checklist™ so you can review your space in minutes.',
  },
  {
    number: 'III',
    title: 'The 7 Nights of The Method',
    description: 'You don’t have to figure out what to do every night. Just follow the path.',
    listLabel: 'Every night includes',
    items: ['One mission', 'One routine', 'One checklist', 'One reflection', 'One simple goal'],
    nights: ['Close the day', 'Prepare your environment', 'Disconnect from screens', 'Introduce your sensory ritual', 'Create a slower transition', 'Build your personal ritual combination', 'Design your ideal nighttime routine'],
  },
  {
    number: 'IV',
    title: 'The Peaceful Night Ritual Library™',
    description: 'Discover 30+ micro-rituals of 3, 5, 10 and 15 minutes for different situations — so you’ll never have to ask: “What should I do tonight?”',
    listLabel: 'For different moments',
    items: ['After a stressful day', 'When you have very little time', 'Sunday evenings', 'After work', 'When you need to disconnect', 'While traveling', 'When you want to reset your routine'],
  },
  {
    number: 'V',
    title: 'Scents & Sensory Rituals',
    description: 'Discover simple ways to incorporate scents as part of your personal nighttime self-care experience.',
    listLabel: 'Includes',
    items: ['Beginner scent guide', 'Common ways to use scents in your environment', 'Scent combinations for different atmospheres', 'Sensory rituals', 'General safety guidelines', 'Beginner checklist', 'Guide to creating your own signature nighttime scent ritual'],
    disclaimer: 'Essential oils are not a substitute for medical care and are not intended to diagnose, treat, or cure medical conditions. Always follow product-specific instructions and appropriate safety precautions.',
  },
  {
    number: 'VI',
    title: 'Your 30-Night Plan',
    description: 'The first 7 nights are only the beginning. This volume helps you turn your new ritual into a sustainable practice.',
    listLabel: 'Includes',
    items: ['30-night calendar', 'Consistency tracker', 'Nighttime journal', 'Weekly review', 'Habit review', 'Reward system', 'Weekend routine', 'Reset plan for getting back on track after missing a night'],
  },
];

export const extras = [
  { icon: 'list', title: '30+ Practical Nighttime Rituals', text: 'Simple ideas for different moments throughout your evening.' },
  { icon: 'check', title: 'Peaceful Night Checklists', text: 'Prepare your environment and routine without having to figure everything out yourself.' },
  { icon: 'calendar', title: '30-Night Calendar', text: 'Turn your first 7 nights into a routine you can maintain.' },
  { icon: 'chart', title: 'Consistency Tracker', text: 'See your progress as you complete your nighttime ritual.' },
  { icon: 'image', title: 'Visual Guides', text: 'Beautiful resources designed to be used from your phone or printed at home.' },
] as const;

export const bonuses = [
  {
    number: 1,
    title: '50 Wind-Down Micro-Rituals',
    value: 37,
    image: 'https://cdn.magicpatterns.com/uploads/ryYCtZyicHtV9Ck7MbK6ek/BONUS_1_NIGHT-EN.png',
    description: 'A collection of simple rituals for nights when you have very little time, very little energy, or simply want to change up your routine.',
    items: ['Options for 3, 5, 10 and 15 minutes'],
  },
  {
    number: 2,
    title: 'The Peaceful Night Bedroom Checklist™',
    value: 27,
    image: 'https://cdn.magicpatterns.com/uploads/vfWFW3o5hCJVxEutXeoyjQ/BONUS_2_NIGHT-EN.png',
    description: 'A visual room audit designed to help you identify simple changes that can make your bedroom feel more prepared for the evening.',
    items: ['Lighting', 'Clutter', 'Screens', 'Sounds', 'Comfort', 'Atmosphere'],
  },
  {
    number: 3,
    title: 'The Digital Wind-Down Protocol™',
    value: 29,
    image: 'https://cdn.magicpatterns.com/uploads/tuzNJWeMA2DZ9w3mdB1wuR/BONUS_3_NIGHT-EN.png',
    description: 'A practical system for creating a gradual transition from phone use to your nighttime ritual.',
    items: ['Digital wind-down routine', 'Checklist', 'Personal rules', 'Alternatives to scrolling', 'Plan for difficult nights'],
  },
  {
    number: 4,
    title: 'The Peaceful Night Journal — 30 Nights',
    value: 27,
    image: 'https://cdn.magicpatterns.com/uploads/wvvn7A2MAPHZL3RQCQknQz/BONUS_4_NIGHT-EN.png',
    description: 'A visual journal to track your evenings, night by night.',
    items: ['How you felt at the end of the day', 'Which ritual you completed', 'What worked', 'What you’d like to change', 'How you experienced your evening'],
  },
  {
    number: 5,
    title: '21 Sensory Ritual Cards',
    value: 27,
    image: 'https://cdn.magicpatterns.com/uploads/q6B23SJ5QBduhx7vuqbbnL/BONUS_5_NIGHT-EN.png',
    description: '21 printable cards featuring simple sensory ritual ideas to incorporate into your nighttime routine. Keep them beside your bed and choose one each night.',
    items: [],
  },
];

export const guaranteeItems = [
  'Explore all 6 volumes',
  'Try the 15-minute ritual',
  'Complete the first nights of the method',
  'Use the checklists',
  'Download the bonuses',
  'Start your 30-night calendar',
];

export const testimonials = [
  { name: 'Anna M.', flag: '🇺🇸', country: 'United States', photo: 'https://cdn.magicpatterns.com/patterns/generated-images/c63f1936-13d1-4b77-a10d-3f4233b9efe8.jpg', quote: 'What I loved most is that I didn’t have to completely change my routine. The 15 minutes made it so much easier to actually get started.' },
  { name: 'Caroline R.', flag: '🇨🇦', country: 'Canada', photo: 'https://cdn.magicpatterns.com/patterns/generated-images/29da8da0-ed61-41d8-9831-1ff86fbe4f59.jpg', quote: 'I had saved so many sleep tips but never actually used them. Here I simply followed the nights one by one.' },
  { name: 'Mariana P.', flag: '🇺🇸', country: 'United States', photo: 'https://cdn.magicpatterns.com/patterns/generated-images/064292f5-8db1-44f7-b314-95aa323f211e.jpg', quote: 'The bedroom checklist was my favorite. It made me realize how many small things I could change without making my routine complicated.' },
  { name: 'Laura G.', flag: '🇬🇧', country: 'United Kingdom', photo: 'https://cdn.magicpatterns.com/patterns/generated-images/7505566a-85d0-4b23-a035-134d416549fc.jpg', quote: 'I didn’t buy another ebook full of advice. I bought a routine I can actually repeat.' },
  { name: 'Danielle S.', flag: '🇦🇺', country: 'Australia', photo: 'https://cdn.magicpatterns.com/patterns/generated-images/2baed9df-11f1-496b-afbd-8bd1b7d231a1.jpg', quote: 'The seven-night structure made having a nighttime routine feel simple for the first time.' },
];

export const faqs = [
  { q: 'How will I receive the materials?', a: 'Immediately after your purchase, you’ll receive an email with instructions to access and download all 6 volumes and 5 bonuses.' },
  { q: 'Do I need any previous experience?', a: 'No. The method is designed for people who have never had a structured nighttime routine before.' },
  { q: 'Do I have to use essential oils?', a: 'No. Scents and essential oils are optional. The core of the method is a simple wind-down and self-care routine.' },
  { q: 'How much time do I need each night?', a: 'The main ritual is designed to take approximately 15 minutes, and you’ll also receive 3-, 5-, and 10-minute versions.' },
  { q: 'Do I have to complete all 7 nights in a row?', a: 'The method is designed around seven nights, but if you miss a night, you can simply continue without starting over.' },
  { q: 'Are the files downloadable?', a: 'Yes. You’ll receive digital materials that can be accessed from your phone, tablet, or computer, with printable resources included.' },
  { q: 'Is this a one-time payment?', a: 'Yes. You pay $27 once and receive access to the product without recurring monthly charges.' },
  { q: 'Does this replace medical treatment for insomnia or anxiety?', a: 'No. The Peaceful Night Method™ is an educational wellness and habit-building product. It does not diagnose, treat, or cure insomnia, anxiety disorders, or other medical conditions. If you have persistent or significant symptoms, consult a qualified healthcare professional.' },
  { q: 'What if it’s not what I expected?', a: 'You have a 7-day money-back guarantee. If you decide the product isn’t right for you, you can request a refund within the guarantee period.' },
];

export const recentBuyers = [
  { name: 'Sofía R.', country: 'Mexico', flag: '🇲🇽' },
  { name: 'Valentina G.', country: 'Argentina', flag: '🇦🇷' },
  { name: 'Camila T.', country: 'Colombia', flag: '🇨🇴' },
  { name: 'Lucía M.', country: 'Spain', flag: '🇪🇸' },
  { name: 'Isabella P.', country: 'Chile', flag: '🇨🇱' },
  { name: 'Daniela F.', country: 'Peru', flag: '🇵🇪' },
  { name: 'Mariana L.', country: 'Uruguay', flag: '🇺🇾' },
  { name: 'Gabriela S.', country: 'Costa Rica', flag: '🇨🇷' },
  { name: 'Andrea V.', country: 'Ecuador', flag: '🇪🇨' },
  { name: 'Paula C.', country: 'Dominican Republic', flag: '🇩🇴' },
  { name: 'Carolina B.', country: 'Guatemala', flag: '🇬🇹' },
  { name: 'Natalia H.', country: 'Puerto Rico', flag: '🇵🇷' },
];
